import { DashboardModule } from '@domain-group/suit-theme'

import { UseCampaignPortalsPayload } from '@hooks/useCampaignPortals'

import ActivePortalListItem from './ActivePortalListItem'

interface ActivePortalsProps {
  campaignPortalsPayload: UseCampaignPortalsPayload,
}

const ActivePortals = (props: ActivePortalsProps) => {
  const { campaignPortalsPayload } = props

  const {
    filteredCampaignPortals,
    hasFilteredCampaignPortals,
    loading,
  } = campaignPortalsPayload

  return (
    <DashboardModule contentBoxProps={{ flexDirection: 'column' }} title="Active Portals">
      {!loading && !hasFilteredCampaignPortals && (
        <DashboardModule.BlankState>
          <DashboardModule.BlankState.Title>
            No Active Portals Present.
          </DashboardModule.BlankState.Title>
        </DashboardModule.BlankState>
      )}

      {!loading && filteredCampaignPortals.map(campaignPortal => (
        <ActivePortalListItem campaignPortal={campaignPortal} key={campaignPortal.id} />
      ))}
    </DashboardModule>
  )
}

export default ActivePortals
